import { render } from "./AddRemboursementPage.vue?vue&type=template&id=1e56a238&ts=true"
import script from "./AddRemboursementPage.vue?vue&type=script&lang=ts"
export * from "./AddRemboursementPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__